import React from 'react';
// @ts-ignore
import { Link } from 'react-router-dom';
class Home extends React.Component {
    constructor(props) {
        super(props);
    }
    render() {
        return (React.createElement(React.Fragment, null,
            React.createElement("div", { className: "row" },
                React.createElement("div", { className: "col-sm-12 content" },
                    React.createElement("p", null, "Nazywam si\u0119 Mateusz Krasuski"),
                    React.createElement("p", null, "Specjalizuj\u0119 si\u0119 w j\u0119zykach takich jak JavaScript/TypeScript do tego ucz\u0119 si\u0119 j\u0119zyka Rust."),
                    React.createElement("p", null, "Stosowane technologie dla JavaScript/TypeScript to:"),
                    React.createElement("ul", null,
                        React.createElement("li", null, "React.js"),
                        React.createElement("li", null, "Node.js"),
                        React.createElement("li", null, "Koa.js"),
                        React.createElement("li", null, "Express.js"),
                        React.createElement("li", null, "Vue.js")),
                    React.createElement("p", null, "Znam r\u00F3wnie\u017C j\u0119zyki takie jak:"),
                    React.createElement("ul", null,
                        React.createElement("li", null, "PHP"),
                        React.createElement("li", null, "C"),
                        React.createElement("li", null, "C++"),
                        React.createElement("li", null, "C#"),
                        React.createElement("li", null, "Podstawy Java")),
                    React.createElement("p", null, "Zajmuj\u0119 si\u0119 frontend-em jak i backend-em."),
                    React.createElement("p", null,
                        "Wszystkie moje projekty s\u0105 do wgl\u0105du w ",
                        React.createElement("a", { href: "https://github.com/Saurus42" }, "moim repozytorium"),
                        " oraz w zak\u0142adce ",
                        React.createElement(Link, { to: "/portfolio/projects" }, "Moje projekty"),
                        ".")))));
    }
}
export default Home;
